// extracted by mini-css-extract-plugin
export default {"container":"LJ-z","timeTop":"MJ-z","timeCountdown":"NJ-z","cta":"OJ-z","disabled":"PJ-z","product":"QJ-z"};